// extracted by mini-css-extract-plugin
module.exports = {"btn":"buttonStyles_btn__Lyagj","link":"buttonStyles_link__R5MiN"};